<template>
  <el-form
    :model="tjbForm"
    ref="form"
    label-width="12%"
    v-loading="loading">
    <!-- <slot name="errMsg"></slot> -->
    <section>
      <div class="title ft-12">
        <span>类目选择</span>
      </div>
      <div class="conf">
        <el-form-item label="商品分类:" prop="categoryIds">
          <div class="category ft-12">
            <category-input
              ref="cinput"
              :categoryIds="tjbForm['categoryIds']"
              :baseItemId="baseItemId" 
              @change="categoryIdsChange"
              platform="tjb" />
          </div>
        </el-form-item>
      </div>
    </section>

    <template v-if="formSections.length">
    <section
      v-for="(section, sectionIndex) in formSections"
      :key="sectionIndex">
      <div class="title ft-12">
        <span>{{section.title}}</span>
      </div>
      <div class='conf'>
        <template v-for="(field) in section.children">
          <el-form-item
            v-if="field.isShowFn ? field.isShowFn(tjbForm) : true"
            :key="field.name"
            :prop="field.name"
            :label="formatLabel(field)"
            :rules="field.rules"
            :class="[noLabelStyles.includes(field.name) ? 'noLabel' : '']"
            >
            <div
              class="preText"
              v-if="field._preText"
              v-html="field._preText"></div>
            <component
              :ref="field.name"
              :is="field.component.component"
              :props="field.component.props"
              @fieldChanged="specificationsFieldChanged"></component>
            <div
              class="suffixText"
              v-if="field._suffixText"
              v-html="field._suffixText"></div>
            <div
              v-if="field.tipRule && field.tipRule.length && (field.isShowTipFn ? field.isShowTipFn(tjbForm) : true) && !(field.name === 'saleProp' && removePureItem && tjbForm.pureType)"
              class="tips ft-12">
              <span
                style="display: block"
                v-for="(tip, tipIndex) in field.tipRule"
                v-html="tip"
                :key="tipIndex"></span>
            </div>
          </el-form-item>
        </template>
      </div>
    </section>
    </template>
    <slot name="shipShelf"></slot>
  </el-form>
</template>

<script>
import CategoryInput from "../../../PlatformCategoryInput/index.vue";

import { mapGetters, mapActions } from 'vuex'
export default {
  components: {
    CategoryInput
  },
  props: {
    formSections: {
      type: Array,
      default: () => [],
    },
    baseItemId: [Number, String],
  },
  data() {
    return {
      loading: false,
      rules: {},
      noLabelNames: ['saleProp', 'globalStock', 'invoice', 'sellPromise'],
      noLabelStyles: ['saleProp', 'globalStock'],
      shopList: [],
      shipsTemplate: {}, // 运费模板列表
      shipsValue: {}, // 运费模板值
      shelfState: 1
    };
  },
  computed: {
    ...mapGetters(["tjbForm", 'removePureItem'])
  },
  methods: {
    ...mapActions(["updateTjbForm"]),
    categoryIdsChange(v) {
      this.updateTjbForm({
        categoryIds: v
      })
      this.$emit("categoryChange", v)
    },
    formatLabel(field) {
      // 需要对部分字段特殊处理 KMERP-68827
      if (field.name === 'warranty') return '售后服务'
      if (field.name === 'tbDeliveryTime') return ' '
      return this.noLabelNames.includes(field.name) ? '' : field.label
    },
    specificationsFieldChanged() {
      this.$emit('fieldChanged')
    },
  }
};
</script>

<style lang="scss" scoped>
.title {
  padding: 10px;
  background: #f8f8f8;
  font-weight: 600;
}
.conf {
  margin-top: 20px;
}
.noLabel {
  & ::v-deep .el-form-item__content {
    margin-left: 0 !important;
  }
  & ::v-deep .el-form-item__error {
    margin-left: 12% !important;
  }
}
.preText, .suffixText {
  font-size: 12px;
  display: inline-block;
}
.preText {
  margin-right: 5px;
}
.suffixText {
  margin-left: 5px;
}
</style>